<template>
  <div>
    <vue-title :title="$t('competitors.title')" />
    <v-btn @click="safety()" color="yellow">Safety sheet</v-btn> &nbsp;
    <v-btn @click="showAll()" color="green">Show all</v-btn> &nbsp;
    <Exporter :data="this.items" :headers="headers" filename="competitors.csv" />
    <v-text-field
          v-model="search"
          append-icon="search"
          :label="$t('ctrl.search')"
          single-line
          hide-details
          @input="searchChanged"
      ></v-text-field>
    <v-data-table 
      v-model="selected" dense disable-pagination
      :items="items" :headers="headers" :search="search" hide-default-footer show-select
      >
      <template v-slot:item.country="{item}">
        <flag :iso="item.country" /> &nbsp;
      </template>
      <template v-slot:item.firstName="{item}">
          <v-tooltip bottom v-if="!item.emailConfirmed">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" small color="red">mail_outline</v-icon>
            </template>
            <span>Email not confirmed</span>
          </v-tooltip>
          <v-tooltip bottom v-if="item.emailConfirmed && !item.profileCompleted">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" small color="red">perm_identity</v-icon>
            </template>
            <span>Profile not completed</span>
          </v-tooltip>
          <span v-if="!item.emailConfirmed || !item.profileCompleted">&nbsp;</span>
          <router-link :to="'competitors/'+item.id">{{ item.firstName }}</router-link>
      </template>
      <template v-slot:item.gender="{item}">
          <v-icon :color="item.gender==1?'red':'blue'">person</v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import {
    VTextField,
    VDataTable,
    VTooltip,
    VCheckbox
  } from 'vuetify/lib'
  import fccapi from '../fccapi.js'
  import pdfMake from 'pdfmake';
  import fonts from '../vfs_fonts.js';
  pdfMake.vfs = fonts;
  import Exporter from '../components/Exporter.vue'

  export default {
    name: 'Competitors',
    data: () => ({
      search: "",
      selected: [],
      items: [ ]
    }),
    computed: {
      headers: function () {
        return [
          { text: "", value: 'country' },
          { text: this.$t('competitors.firstName'), value: 'firstName' },
          { text: this.$t('competitors.lastName'), value: 'lastName' },
          { text: this.$t('competitors.gender'), value: 'gender' },
          { text: this.$t('competitors.department'), value: 'department' },
          { text: this.$t('competitors.email'), value: 'email' },
          { text: this.$t('competitor.shirtSize'), value: 'shirtSize' }
        ]
      },
      genders: function () { 
        return [this.$t("profile.male"), this.$t("profile.female")]
      },
      selectedCompetition: function() {
        return this.$store.getters['competitionId'];
      }
    },
    methods: {
      safety: function(){
        var promises = [];
        var organizer = this.$store.getters['competition'].organizer;
        var se = this.selected.sort((a, b) => (a.firstName > b.firstName) ? 1 : -1);
        for(var i = 0; i < this.selected.length; i++){
          var s = se[i];
          var p = fccapi.get(`competitors/${s.id}/safety/${this.$store.getters['competitionId']}`);
          promises.push(p);
        }
        Promise.all(promises).then(function (values) {
          var docDefinition;
          for (var i = 0; i < values.length; i++) {
            if (!docDefinition) {
              docDefinition = values[i].data;
            }
            else {
              for (var j = 0; j < values[i].data.content.length; j++) {
                docDefinition.content.push(values[i].data.content[j]);
              }
            }
          }

          //docDefinition.watermark = { image: testImageDataUrl, width: 200 };//'/images/watermark.png' };
          /*docDefinition.footer = (currentPage, pageCount, pageSize) => {
            return [
              {
                //text: "Organizator tekmovanja je\nProstovoljno gasilsko društvo Radovljica, Gorenjska cesta 31, 4240 Radovljica",
                text: "Competition organizer:\n"+organizer.longName+", "+organizer.address,
                alignment: 'center',
                margin: [20, -25, 20, 20]
              }
            ]
          };*/
          docDefinition.content.splice(-1, 1);
          var filename = values.length + " safety sheets.pdf";
          pdfMake.createPdf(docDefinition).download(filename);
        });
      },
      showAll: function(){
        fccapi.get('competitors').then((r) => {
          this.items = r.data;
        })
      },
      reload: function(){
        fccapi.competitionGet('competitors').then((r) => {
          this.items = r.data;
        })
        this.search = this.$route.query.s;
      },
      searchChanged: function(){
        
      }
    },
    props: {
      source: String
    },
    components: {
      VDataTable,
      VTextField,
      VTooltip,
      VCheckbox,
      Exporter
    },
    mounted() {
      this.reload();
    },
    watch: {
      selectedCompetition() {
        this.reload();
      }
    }
  }
</script>